import { ref } from 'vue'

import { logService, LOG_CATEGORIES } from '@/services/logService'

interface DialogOptions {
  title: string
  message: string
  confirmText?: string
  cancelText?: string
  variant?: 'danger' | 'warning' | 'info'
}

interface DialogInstance {
  showConfirm: (options: DialogOptions) => Promise<boolean>
}

// Reference to the dialog component
const dialogRef = ref<DialogInstance | null>(null)

/**
 * Sets the dialog component reference
 */
export function setDialogRef(instance: DialogInstance | null) {
  dialogRef.value = instance
}

/**
 * Shows a confirmation dialog and returns a promise that resolves to true if confirmed
 */
export function showConfirm(options: DialogOptions): Promise<boolean> {
  if (dialogRef.value) {
    return dialogRef.value.showConfirm(options)
  }

  // Fallback if dialog component is not available
  logService.warn(
    LOG_CATEGORIES.UI,
    'No dialog component registered, using window.confirm fallback',
    { options },
  )
  return Promise.resolve(window.confirm(options.message))
}
